import {
  UinixResponsiveStyle,
  UinixStyleValue,
} from '../../../types/ResponsiveStyle';

/**
 * Creates responsive margin values based on direction and spacing.
 * Assumes that if they are arrays, direction and spacing are the same length. (Converted from ResponsiveStyle object to array with transformResponsiveStyleValue).
 * However it is possible to have one as responsive array and the other as a primitive value.
 */
export const getResponsiveSpacing = (
  spacing: UinixResponsiveStyle,
  direction: UinixResponsiveStyle = 'row',
): {
  marginBottom: UinixResponsiveStyle;
  marginRight: UinixResponsiveStyle;
} => {
  if (spacing === undefined) {
    return { marginBottom: undefined, marginRight: undefined };
  }

  // convert both to arrays, so that they can be iterated over and assigned values for each breakpoint
  const normalizedSpacing = Array.isArray(spacing) ? spacing : [spacing];
  const normalizedDirection = Array.isArray(direction)
    ? direction
    : new Array(normalizedSpacing.length).fill(direction);

  const marginBottom: UinixResponsiveStyle = [];
  const marginRight: UinixResponsiveStyle = [];
  let lastDirection = normalizedDirection[0] ?? 'row';
  let lastSpacing = normalizedSpacing[0] ?? 0;

  normalizedDirection.forEach((dir: UinixStyleValue, index: number) => {
    lastDirection = dir ?? lastDirection;
    lastSpacing = normalizedSpacing[index] ?? lastSpacing;

    marginBottom[index] = lastDirection.includes('column') ? lastSpacing : 0;
    marginRight[index] = lastDirection.includes('row') ? lastSpacing : 0;
  });

  return { marginBottom, marginRight };
};
